import { Card } from 'components/tailwind-ui/Card';
import { PresetView, usePreset } from 'pages/Shipments/Containers/types';
import { useTrackSegment } from 'pages/Shipments/Dashboard/hooks';
import React from 'react';
import { Link } from 'react-router-dom';
import { KeyMetric } from './KeyMetric';

interface Props {
  title: string;
  value: string | React.ReactNode;
  color?: string;
  presetView?: PresetView;
  to?: string;
}

export const KeyMetricCard: React.FC<Props> = (props) => {
  const { title, value, color, presetView, to } = props;

  const preset = usePreset(presetView || PresetView.Active);
  const handleClick = useTrackSegment(presetView || PresetView.Active, 'historical-per-diem');

  return (
    <Card className="flex">
      {to || presetView ? (
        <Link
          to={to || preset.to}
          onClick={handleClick}
          className="group px-4 py-2 hover:bg-gray-100 hover:border-blue-900 transition-colors flex grow"
        >
          <KeyMetric
            title={title}
            value={value}
            color={color}
            showArrow
            className="space-y-[2px]"
          />
        </Link>
      ) : (
        <KeyMetric title={title} value={value} color={color} className="space-y-[2px] px-4 py-2" />
      )}
    </Card>
  );
};
